// @ts-nocheck
import React, { useState, useEffect } from "react";
import { lazy } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import lodash from "lodash";
import {
  Box,
  Button,
  Grid,
  Typography,
  Modal,
  CircularProgress,
  useMediaQuery,
  Checkbox,
  InputLabel,
  Tooltip,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import * as Yup from "yup";
import { useFormik } from "formik";
import sessionStyles from "../sessions/sessions.module.css";
import styles from "./eventDetails.module.css";
import congratulationStyles from "../../../congratulations/congratulations.module.css";
import {
  clearSessionStep1DataAction,
  clearSessionStep2FormAction,
  deleteSessionAction,
  getSessionssOfSpecificEvent,
  resetCreateEventSlice,
  setSessionData,
  updatePositionAction,
  updateSubmittedKey,
} from "../../../../store/actions/createEvent";
import { getAllPositions } from "../../../../store/actions/positions";
import EventInformation from "../../../event-details/EventInformation";
import ContactInformation from "../../../event-details/ContactInformation";
import SessionPositions from "../sessions/step2/SessionPositions";

import {
  handleDeletePosition,
  handleEditPosition,
} from "../sessions/sessionHandlers";
import {
  getFullDateStr,
  convertFromUTCToGivenTimezone,
  convertFromGivenTimezoneToUTC,
} from "../../../../utils/methods/dateAndTimeMethods";
import { getCssVariableHandler } from "../../../../utils/styles/getCssVariables";
import SessionList from "../sessions/step3/SessionList";
import AddPositionForm from "../sessions/step2/AddPositionForm/AddPositionForm";
import ReusableParentContainer from "../../../../components/Custom/ReusableParentContainer";
const Congratulations = lazy(
  () => import("../../../congratulations/Congratulations"),
);
import { ALERT_DIALOG } from "../../../../store/constants/auth";
import LoadingOverlay from "../../../../components/Custom/LoadingOverlay";
import { dateRegex } from "../../../../utils/constants/dateRegex";
import SessionPositionEditableSheetOptimized from "./SessionPositionEditableSheetOptimized";
import { CustomSwitch } from "../../../../components/Custom/Switch";
import { toggleHelper } from "../../../../store/actions/auth";
import InfoImage from "../../../../assets/createEvent/small-info.svg";
import dayjs from "dayjs";
import { CheckBox, MoreHoriz } from "@mui/icons-material";
import GenericTransparentBtn from "../../../../components/Custom/GenericTransparentBtn";
import FileSaver from "file-saver";
import * as ExcelJS from "exceljs";
import { fetchCoordinatorsContractorsAndClientsAction } from "../../../../store/actions/createEventActions2";
import { alertDialogAciton } from "../../../../store/actions/auth";
import { isUserRole, isActiveRole } from "../../../../utils/methods/storeFunc";
import { USER_ROLES } from "../../../../staticData/userRoles";

// Route that opens a freshly created (not yet approved) event for the active
// role — same target the row links use in Dashboard / EventRequest / AllEvents.
// Returns null for roles without that page (guest, freelance EC), which keep
// the "Thank you" screen.
const getCreatedEventDetailsRoute = () => {
  if (
    isActiveRole(
      USER_ROLES.ADMIN,
      USER_ROLES.SUPERADMIN,
      USER_ROLES.CLIENT,
      USER_ROLES.COORDINATOR,
    )
  ) {
    return "/event/new-request/details";
  }
  return null;
};

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//     [`&.${tableCellClasses.head}`]: {
//         backgroundColor: theme.palette.common.black,
//         color: theme.palette.common.white,
//     },
//     [`&.${tableCellClasses.body}`]: {
//         fontSize: 14,
//     },
// }))

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//     '&:nth-of-type(odd)': {
//         backgroundColor: theme.palette.action.hover,
//     },
//     // hide last border
//     '&:last-child td, &:last-child th': {
//         border: 0,
//     },
// }));

export const CongratulationsNavButtonsVariant1 = ({
  homeButtonHandler,
  newEventHandler,
  setCurrentStep,
}) => {
  const dispatch = useDispatch();

  return (
    <Box className={congratulationStyles.ctrls}>
      <Button
        // to="/create-event"
        onClick={() => {
          // homeButtonHandler ? homeButtonHandler?.({
          //     navigate
          // }) : null;
          setCurrentStep?.(1);
          dispatch(resetCreateEventSlice());
        }}
      >
        Back Home
      </Button>
      <Button
        // to="/create-event"
        onClick={() => {
          // newEventHandler ? newEventHandler?.({
          //     navigate
          // }) : null;
          setCurrentStep?.(1);
          dispatch(resetCreateEventSlice());
        }}
      >
        Build New Event
      </Button>
    </Box>
  );
};

export const CongratulationsNavButtonsVariant2 = ({ closeHandler }) => {
  return (
    <Box className={congratulationStyles.ctrls}>
      <Button
        onClick={() => {
          closeHandler();
        }}
      >
        Close
      </Button>
    </Box>
  );
};

/**
 * Event review: event + contact info, sessions and their positions.
 *
 * variant="step"    - step 4 of the create-event wizard: sheet download menu,
 *                     "send email" option and Back / Edit Event / Submit.
 * variant="preview" - read-and-edit popup opened from the wizard header: no
 *                     submit, help switch on top, fits inside a modal.
 */
const EventDetails = ({
  variant = "step",
  sendEmail = true,
  onSendEmailChange = () => {},
  setStep,
  handlePrevStep,
  handleNextStep,
  currentStep,
  setCurrentStep,
  setEditSessionData,
  closeHandler,
  NavButtonsComponent,
  navButtonsComponentProps,
  editSessionCallbackParent,
}) => {
  const isPreview = variant === "preview";
  // static variables start...
  const initialValuesInit = React.useMemo(() => {
    return {
      // position: "",
      positions: [],
      PPE_Requirements: "",
      positionName: "",
      dateStart: "",
      timeIn: "",
      timeOut: "",
      tbd: false,
      numberOfHours: "",
      quantity: "",
      complexity: "",
      option: "",
      attire: "",
      comments: "",
      overNightShift: false,
    };
  }, []);

  const showMenuItemsInit = React.useMemo(() => {
    return {
      uploadEventFromSheetButtons: false,
    };
  }, []);

  const initialAndCurrentSchemaComparison = {
    positionName: function (values) {
      if (values?.initialValue?.trim?.() !== values?.currentValue?.trim?.()) {
        return values;
      } else {
        return null;
      }
    },
    dateStart: function (values) {
      if (values?.initialValue?.trim?.() !== values?.currentValue?.trim?.()) {
        return values;
      } else {
        return null;
      }
    },
    PPE_Requirements: function (values) {
      if (values?.initialValue?.trim?.() !== values?.currentValue?.trim?.()) {
        return values;
      } else {
        return null;
      }
    },
    timeIn: function (values) {
      if (
        !dateRegex.test(values?.initialValue) ||
        !dateRegex.test(values?.currentValue)
      ) {
        return null;
      } else if (
        new Date(values?.initialValue?.trim?.())?.toISOString?.() !==
        new Date(values?.currentValue?.trim?.())?.toISOString?.()
      ) {
        return values;
      } else {
        return null;
      }
    },
    timeOut: function (values) {
      if (
        !dateRegex.test(values?.initialValue) ||
        !dateRegex.test(values?.currentValue)
      ) {
        return null;
      } else if (
        new Date(values?.initialValue?.trim?.())?.toISOString?.() !==
        new Date(values?.currentValue?.trim?.())?.toISOString?.()
      ) {
        return values;
      } else {
        return null;
      }
    },
    quantity: function (values) {
      if (values?.initialValue?.trim?.() !== values?.currentValue?.trim?.()) {
        return values;
      } else {
        return null;
      }
    },
    complexity: function (values) {
      if (values?.initialValue?.trim?.() !== values?.currentValue?.trim?.()) {
        return values;
      } else {
        return null;
      }
    },
    option: function (values) {
      if (values?.initialValue?.trim?.() !== values?.currentValue?.trim?.()) {
        return values;
      } else {
        return null;
      }
    },
    attire: function (values) {
      if (values?.initialValue?.trim?.() !== values?.currentValue?.trim?.()) {
        return values;
      } else {
        return null;
      }
    },
    comments: function (values) {
      if (values?.initialValue?.trim?.() !== values?.currentValue?.trim?.()) {
        return values;
      } else {
        return null;
      }
    },
  };

  const mappingFromFrontendFieldNamesToBackendFieldNames = {
    positionName: "positionName",
    dateStart: "startDate",
    PPE_Requirements: "PPE_Requirements",
    timeIn: "timeIn",
    timeOut: "timeOut",
    quantity: "quantity",
    complexity: "complexity",
    option: "option",
    attire: "attire",
    comments: "additionalComments",
  };
  // static variables end...

  // media query hooks...
  const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  // media query hooks...

  const navigate = useNavigate();

  const dispatch = useDispatch();

  // Selectors start...
  const auth = useSelector((store) => store.auth);
  const helpStatus = auth?.helpStatus;
  const createContactInfo = useSelector((store) => store.createContactInfo);
  const positionsReducer = useSelector((store) => store.positions);
  const editEventButton = useSelector(
    (state) => state?.createContactInfo?.editEventButton,
  );
  // const positions = useSelector((state) => state.createContactInfo.positions);
  // Selectors end...

  const eventInfo = createContactInfo?.eventInfo;
  const contactInfo = createContactInfo?.contactInfo;

  // const positionOptions = useMemo(() => {
  //     return positions?.map((position) => ({
  //       value: position._id,
  //       label: position.positionName,
  //       ...position
  //     }));
  // }, [positions]);

  // State variables start...
  const [initialValues, setInitialValues] = React.useState(initialValuesInit);
  const [viewAllSessionsPositions, setViewAllSessionsPositions] =
    React.useState(false);
  const [selectedSessionId, setSelectedSessionId] = useState(
    createContactInfo?.sessionsOfEvent?.[0]?._id,
  );
  const [editingSessionPositionId, setEditingSessionPositionId] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [options, setOptions] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState(options || []);
  const [sessionPositionsTableData, setSessionPositionsTableData] = useState(
    [],
  );
  const [positionsTablePageNo, setPositionsTablePageNo] = useState(1);
  const [positionsTableLimit, setPositionsTableLimit] = useState(10);
  const [toBeDeletedSession, setToBeDeletedSession] = useState(null);
  const [deleteSessionLoading, setDeleteSessionLoading] = useState(false);
  const [isEventSubmitted, setIsEventSubmitted] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [sheetStatus, setSheetStatus] = React.useState({
    positionSheet: false,
  });
  const [viewPositionsData, setViewPositionsData] = useState({
    positions: [],
    selectedSessions: createContactInfo?.sessionsOfEvent?.filter?.(
      (session) => {
        return session?._id === selectedSessionId;
      },
    ),
  });
  const [showMenuItems, setShowMenuItems] = React.useState(showMenuItemsInit);
  const [
    isDownloadUploadEventFromSheetLoading,
    setIsDownloadUploadEventFromSheetLoading,
  ] = React.useState(false);
  // State variables end...

  const selectedSession =
    createContactInfo?.sessionsOfEvent?.filter?.((session) => {
      return session?._id === selectedSessionId;
    })?.[0] || null;

  // Edit position form...
  const formSchema = Yup.object().shape({
    // position: Yup.string().trim().required("Position required"),
    positions: Yup.array().of(Yup.object().required("Position required")),
    PPE_Requirements: Yup.string().trim(),
    dateStart: Yup.string().trim().required("Start date required"),
    timeIn: Yup.string()
      .trim()
      .when("tbd", {
        is: false,
        then: () => Yup.string().trim().required("Time in is required"),
        otherwise: () => Yup.string().trim(),
      }),
    timeOut: Yup.string()
      .trim()
      .when("tbd", {
        is: false,
        then: () =>
          Yup.string()
            .trim()
            .test(
              "is-greater-than-or-equal-to-time-in",
              "Time out should be greater than or equal to Time in",
              function (code) {
                if (this.parent.overNightShift) {
                  return true;
                }

                if (this.parent.timeIn && this.parent.timeOut) {
                  const timeInDate = new Date(this.parent.timeIn);
                  const timeOutDate = new Date(this.parent.timeOut);

                  return timeOutDate >= timeInDate;
                } else {
                  return true;
                }
              },
            )
            .required("Time out is required"),
        otherwise: () => Yup.string().trim(),
      }),
    tbd: Yup.boolean(),
    numberOfHours: Yup.number().when("tbd", {
      is: true,
      then: () => Yup.number().required("No. of hours required"),
    }),
    overNightShift: Yup.boolean().required("Overnight shift required!"),
    complexity: Yup.string().trim(),
    option: Yup.string().trim(),
    attire: Yup.string().trim(),
    comments: Yup.string()
      .trim()
      .max(255, "comment should be at most 255 characters!"),
  });

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: formSchema,
    onSubmit: (values) => {
      // const timeInAndTimeOutDates = extractFormattedTime({
      //   timeIn: values?.timeIn,
      //   timeOut: values?.timeOut,
      // });

      let data = {
        id: values?.id,
        positionId: values?.positions?.[0]?._id,
        positionName: values?.positions?.[0]?.positionName,
        startDate: values.dateStart?.split?.("T")?.[0],
        timeIn: dateRegex.test(values?.timeIn?.split?.("T")?.[0])
          ? convertFromGivenTimezoneToUTC({
              date: values?.timeIn,
              timezone: eventInfo?.eventTimezone,
            })
          : "TBD",
        timeOut: values?.tbd
          ? "TBD"
          : convertFromGivenTimezoneToUTC({
              date: values?.timeOut,
              timezone: eventInfo?.eventTimezone,
            }),
        numberOfHours: values?.tbd ? values?.numberOfHours : null,
        overNightShift: values.overNightShift,
        quantity: values.quantity,
        complexity: values.complexity,
        selectOption: values.option,
        attire: values.attire,
        additionalComments: values.comments,
        PPE_Requirements: values.PPE_Requirements,
      };

      // const afterAddPositions = () => {
      //   // dispatch(getAllSessionsPositions(sessionStep1?._id));
      //   dispatch(getSessionssOfSpecificEvent(eventInfo?._id));
      //   // handleStepUp();
      //   resetForm({
      //     values: initialValues,
      //   });
      //   setSearchTerm("");
      //   setEditingSessionPositionId("");
      // };

      dispatch(
        updatePositionAction({
          sessionId: selectedSessionId,
          eventInfo,
          payload: data,
          initialValues: getChangedValues()?.initialFields,
          changedValues: getChangedValues()?.currentFields,
          description: `${values.positions?.[0]?.positionName} is edited!`,
          successCallback: afterAddPositions,
          userAuth: eventInfo?.userId ? auth : null,
        }),
      );
    },
    // onSubmit
  });

  const {
    values,
    setValues,
    submitForm,
    resetForm,
  } = formik;
  // Edit position form...

  // Handlers start...
  const afterAddPositions = () => {
    // dispatch(getAllSessionsPositions(sessionStep1?._id));
    dispatch(getSessionssOfSpecificEvent(eventInfo?._id));
    // handleStepUp();
    resetForm({
      values: initialValues,
    });
    setSearchTerm("");
    setEditingSessionPositionId("");
  };

  const getChangedValues = () => {
    const valuesArr = Object.entries(values);

    const initialFields = {};
    const currentFields = {};

    let currentField;

    for (let i = 0; i < valuesArr?.length; i++) {
      currentField = initialAndCurrentSchemaComparison?.[valuesArr?.[i]?.[0]]?.(
        {
          initialValue: initialValues?.[valuesArr?.[i]?.[0]],
          currentValue: valuesArr?.[i]?.[1],
        },
      );

      if (currentField !== null) {
        initialFields[
          mappingFromFrontendFieldNamesToBackendFieldNames[valuesArr?.[i]?.[0]]
        ] = currentField?.initialValue;
        currentFields[
          mappingFromFrontendFieldNamesToBackendFieldNames[valuesArr?.[i]?.[0]]
        ] = currentField?.currentValue;
      }
    }

    return {
      initialFields,
      currentFields,
    };
  };

  const calculateTotalSessionPositionsHandler = (positionArr) => {
    let positionsCount = 0;

    for (let i = 0; i < positionArr?.length; i++) {
      positionsCount += positionArr?.[i]?.positionData?.length;
    }

    return positionsCount;
  };

  const getSessionOfPosition = ({ positionId }) => {
    for (let i = 0; i < createContactInfo?.sessionsOfEvent?.length; i++) {
      for (
        let j = 0;
        j < createContactInfo?.sessionsOfEvent?.[i]?.position?.length;
        j++
      ) {
        for (
          let k = 0;
          k <
          createContactInfo?.sessionsOfEvent?.[i]?.position?.[j]?.positionData
            ?.length;
          k++
        ) {
          if (
            createContactInfo?.sessionsOfEvent?.[i]?.position?.[j]
              ?.positionData?.[k]?._id === positionId
          ) {
            setSelectedSessionId(createContactInfo?.sessionsOfEvent?.[i]?._id);
            // return createContactInfo?.sessionsOfEvent?.[i]?._id;
          }
        }
      }
    }
  };

  const deleteSessionHandler = ({
    deleteSessionCallback,
    deleteSessionFailureCallback,
    payload,
  }) => {
    const afterSuccess = ({ sessionId }) => {
      dispatch(getSessionssOfSpecificEvent(eventInfo?._id));
      setToBeDeletedSession(null);
      setDeleteSessionLoading(false);
      if (sessionId === selectedSessionId) {
        setSelectedSessionId("");
      }

      if (deleteSessionCallback) {
        deleteSessionCallback();
      }
    };

    const afterFailure = () => {
      if (deleteSessionFailureCallback) {
        deleteSessionFailureCallback();
      }
    };

    const afterRequestCallback = () => {
      setConfirmPassword("");
    };

    dispatch(
      deleteSessionAction({
        payload: {
          ...(payload || {}),
          confirmationPassword: confirmPassword,
        },
        sessionId: toBeDeletedSession?._id,
        session: toBeDeletedSession,
        eventInfo,
        successCallback: afterSuccess,
        failureCallback: afterFailure,
        afterRequestCallback,
      }),
    );

    setDeleteSessionLoading(true);
  };

  const editSessionCallback = (e) => {
    setCurrentStep(3);
    editSessionCallbackParent?.();
  };

  const closeEditSessionPositionModalHandler = () => {
    setEditingSessionPositionId("");
    dispatch(clearSessionStep1DataAction());
    dispatch(clearSessionStep2FormAction({}));
  };

  const cancelSessionPositionEditHandler = () => {
    setEditingSessionPositionId("");
    dispatch(clearSessionStep1DataAction());
    dispatch(clearSessionStep2FormAction({}));
    resetForm({
      values: initialValues,
    });
  };

  const onClickGivenSessionHandler = (e, item) => {
    setSelectedSessionId(item?._id);
  };

  const escapeSearchRegex = (str) => {
    return str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
  };

  const homeButtonHandler = () => {
    dispatch(resetCreateEventSlice());
  };

  const newEventHandler = () => {
    dispatch(resetCreateEventSlice());
  };

  const closeEventHandler = () => {
    dispatch(resetCreateEventSlice());
    closeHandler();
  };

  const submitEventSuccessCallback = () => {
    // Read before the slice reset wipes eventInfo/contactInfo.
    const createdEventId = eventInfo?._id;
    const detailsRoute =
      auth?.userToken && createdEventId ? getCreatedEventDetailsRoute() : null;

    dispatch(resetCreateEventSlice());

    if (detailsRoute) {
      // Logged-in user: open the event that was just created instead of
      // showing the "Thank you" screen and dropping back on the list.
      navigate(detailsRoute, {
        state: {
          id: createdEventId,
          contactId: contactInfo?._id ?? null,
          coordinatorId: eventInfo?.assignedCoordinatorId?.[0] ?? null,
        },
      });
      return;
    }

    setIsEventSubmitted(true);
  };

  const checkAtleastOneSessionAndPositionHandler = () => {
    let result = false;

    for (let i = 0; i < createContactInfo?.sessionsOfEvent?.length; i++) {
      if (createContactInfo?.sessionsOfEvent?.[i]?.position?.length > 0) {
        result = true;
        break;
      }
    }

    return result;
  };

  const getPositionsDataHandler = ({ sessions }) => {
    let sessionPositionsTableDataTemp = [];

    for (let session of sessions) {
      for (let i = 0; i < session?.position?.length; i++) {
        for (let j = 0; j < session?.position?.[i]?.positionData?.length; j++) {
          sessionPositionsTableDataTemp.push({
            ...session?.position?.[i]?.positionData?.[j],
            timeIn: dateRegex.test(
              session?.position?.[i]?.positionData?.[j]?.timeIn?.split?.(
                "T",
              )?.[0],
            )
              ? convertFromUTCToGivenTimezone({
                  dateStr: session?.position?.[i]?.positionData?.[j]?.timeIn,
                  timezone: eventInfo?.eventTimezone,
                })
              : session?.position?.[i]?.positionData?.[j]?.timeIn,
            timeOut: dateRegex.test(
              session?.position?.[i]?.positionData?.[j]?.timeOut?.split?.(
                "T",
              )?.[0],
            )
              ? convertFromUTCToGivenTimezone({
                  dateStr: session?.position?.[i]?.positionData?.[j]?.timeOut,
                  timezone: eventInfo?.eventTimezone,
                })
              : session?.position?.[i]?.positionData?.[j]?.timeOut,
            positionId: session?.position?.[i]?.positionId,
            session,
          });
        }
      }
    }

    const sessionPositionsGroupedObj = {};
    let sessionPositionsGroupedArr = [];
    let timeIn;

    for (let i = 0; i < sessionPositionsTableDataTemp?.length; i++) {
      timeIn = getFullDateStr(sessionPositionsTableDataTemp?.[i]?.timeIn);

      if (!sessionPositionsGroupedObj[timeIn]) {
        sessionPositionsGroupedObj[timeIn] = [
          sessionPositionsTableDataTemp?.[i],
        ];
      } else {
        sessionPositionsGroupedObj[timeIn]?.push(
          sessionPositionsTableDataTemp?.[i],
        );
      }
    }

    sessionPositionsGroupedArr = Object.entries(
      sessionPositionsGroupedObj,
    )?.sort((a, b) => {
      const aDt = new Date(a?.[0]);
      const bDt = new Date(b?.[0]);

      if (aDt < bDt) {
        return -1;
      }

      if (aDt > bDt) {
        return 1;
      }

      return 0;
    });

    sessionPositionsTableDataTemp = [];

    for (let i = 0; i < sessionPositionsGroupedArr?.length; i++) {
      for (let j = 0; j < sessionPositionsGroupedArr?.[i]?.[1]?.length; j++) {
        sessionPositionsTableDataTemp?.push(
          sessionPositionsGroupedArr?.[i]?.[1]?.[j],
        );
      }
    }

    // sessionPositionsTableDataTemp = sessionPositionsTableDataTemp
    //   ?.filter((position, positionIdx) => {
    //     return (positionIdx >= ((positionsTablePageNo - 1) * positionsTableLimit) &&
    //       positionIdx < ((positionsTablePageNo - 1) * positionsTableLimit) + positionsTableLimit);
    //   });

    return sessionPositionsTableDataTemp;
    // setSessionPositionsTableData(sessionPositionsTableDataTemp);
  };

  const downloadEventUploadSheetHandler = async () => {
    dispatch(
      fetchCoordinatorsContractorsAndClientsAction({
        beforeCallback: () => {
          setIsDownloadUploadEventFromSheetLoading(true);
        },
        successCallback: async ({ response }) => {
          const allCoordinators = response?.coordinators?.data?.data;
          const allContractors = response?.contractors?.data?.data;
          const clients = response?.clients?.data?.data;

          const workbook = new ExcelJS.Workbook();

          for (let i = 0; i < createContactInfo?.sessionsOfEvent?.length; i++) {
            const worksheet = workbook.addWorksheet(
              createContactInfo?.sessionsOfEvent?.[i]?.sessionName,
            );

            worksheet.getRow(6).values = [
              "Date*",
              "Position*",
              "Name",
              "Phone",
              "Email",
              "SOW",
              "Notes",
              "CC",
              "Client Rate",
              "Rate",
              "Call Start*",
              "Call End*",
              "Notes",
              "Actual Start",
              "1st Break",
              "In",
              "2nd Break",
              "In",
              "Actual End",
              "OT",
              "DT",
              "Meal Penalty",
              "Notes",
            ];

            for (let col = 1; col <= 23; col++) {
              // Example: Covering columns A to W
              const cell = worksheet.getCell(5, col);
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FF808080" },
              };
            }

            const positionTableCells = ["C", "D", "E"];
            for (let i = 0; i < positionTableCells?.length; i++) {
              const cell = worksheet.getCell(`${positionTableCells[i]}7`);
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFD9EAD3" },
              };
              // Set black border
              cell.border = {
                top: { style: "thin", color: { argb: "FF000000" } },
                left: { style: "thin", color: { argb: "FF000000" } },
                bottom: { style: "thin", color: { argb: "FF000000" } },
                right: { style: "thin", color: { argb: "FF000000" } },
              };
            }

            worksheet.getRow(6).eachCell((cell, colNumber) => {
              if (cell?._address === "A6") {
                worksheet.getColumn(colNumber).width = 15; // Minimum width of 10
              } else if (cell?._address === "B6") {
                worksheet.getColumn(colNumber).width = 20; // Minimum width of 10
              } else if (cell?._address === "C6") {
                worksheet.getColumn(colNumber).width = 20; // Minimum width of 10
              } else if (cell?._address === "D6") {
                worksheet.getColumn(colNumber).width = 17; // Minimum width of 10
              } else if (cell?._address === "E6") {
                worksheet.getColumn(colNumber).width = 20; // Minimum width of 10
              } else if (cell?._address === "F6") {
                worksheet.getColumn(colNumber).width = 20; // Minimum width of 10
              } else if (cell?._address === "G6") {
                worksheet.getColumn(colNumber).width = 25; // Minimum width of 10
              } else if (cell?._address === "H6") {
                worksheet.getColumn(colNumber).width = 12; // Minimum width of 10
              } else if (cell?._address === "I6") {
                worksheet.getColumn(colNumber).width = 12; // Minimum width of 10
              } else if (cell?._address === "J6") {
                worksheet.getColumn(colNumber).width = 9; // Minimum width of 10
              } else if (cell?._address === "K6") {
                worksheet.getColumn(colNumber).width = 12; // Minimum width of 10
              } else if (cell?._address === "L6") {
                worksheet.getColumn(colNumber).width = 12; // Minimum width of 10
              } else if (cell?._address === "M6") {
                worksheet.getColumn(colNumber).width = 20; // Minimum width of 10
              } else if (cell?._address === "N6") {
                worksheet.getColumn(colNumber).width = 12; // Minimum width of 10
              } else if (cell?._address === "O6") {
                worksheet.getColumn(colNumber).width = 11; // Minimum width of 10
              } else if (cell?._address === "P6") {
                worksheet.getColumn(colNumber).width = 9; // Minimum width of 10
              } else if (cell?._address === "Q6") {
                worksheet.getColumn(colNumber).width = 11; // Minimum width of 10
              } else if (cell?._address === "R6") {
                worksheet.getColumn(colNumber).width = 9; // Minimum width of 10
              } else if (cell?._address === "S6") {
                worksheet.getColumn(colNumber).width = 12; // Minimum width of 10
              } else if (cell?._address === "T6") {
                worksheet.getColumn(colNumber).width = 7; // Minimum width of 10
              } else if (cell?._address === "U6") {
                worksheet.getColumn(colNumber).width = 7; // Minimum width of 10
              } else if (cell?._address === "V6") {
                worksheet.getColumn(colNumber).width = 15; // Minimum width of 10
              } else if (cell?._address === "W6") {
                worksheet.getColumn(colNumber).width = 20; // Minimum width of 10
              }
            });

            const cells = [
              "A6",
              "B6",
              "C6",
              "D6",
              "E6",
              "F6",
              "G6",
              "H6",
              "I6",
              "J6",
              "K6",
              "L6",
              "M6",
              "N6",
              "O6",
              "P6",
              "Q6",
              "R6",
              "S6",
              "T6",
              "U6",
              "V6",
              "W6",
            ];

            for (let i = 0; i < cells?.length; i++) {
              worksheet.getCell(cells[i]).font = {
                bold: true,
                size: 11,
              };

              worksheet.getCell(cells[i]).fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FF76F8FC" }, // Cyan-like background
              };

              worksheet.getCell(cells[i]).border = {
                top: { style: "thin", color: { argb: "FF000000" } }, // Black
                left: { style: "thin", color: { argb: "FF000000" } },
                bottom: { style: "thin", color: { argb: "FF000000" } },
                right: { style: "thin", color: { argb: "FF000000" } },
              };
            }

            worksheet.getCell("C1").value =
              createContactInfo?.eventInfo?.eventName;
            worksheet.getCell("A1").value = "Show*:";
            worksheet.getCell("A1").font = { size: 14 };

            worksheet.getCell("A2").value = "Client:";
            worksheet.getCell("A2").font = { size: 14 };

            worksheet.getCell("C2").value =
              `${createContactInfo?.contactInfo?.firstName} ${createContactInfo?.contactInfo?.lastName} (${createContactInfo?.contactInfo?._id})`;
            worksheet.getCell("C2").dataValidation = {
              type: "list",
              allowBlank: true,
              formulae: [
                `"${clients
                  ?.map((client) => {
                    return `${client?.firstName} ${client?.lastName} (${client?._id})`;
                  })
                  ?.join(",")}"`,
              ],
            };

            worksheet.getCell("A3").value = "Job Number:";
            worksheet.getCell("A3").font = { size: 14 };

            worksheet.getCell("A4").value = "Estimate:";
            worksheet.getCell("A4").font = { size: 14 };

            worksheet.getCell("F1").value = createContactInfo?.eventInfo?.venue;
            worksheet.getCell("D1").value = "Venue*:";
            worksheet.getCell("D1").font = { size: 14 };

            worksheet.getCell("D2").value = "Checkin:";
            worksheet.getCell("D2").font = { size: 14 };
            worksheet.getCell("F2").value =
              createContactInfo?.sessionsOfEvent?.[i]?.venue;

            worksheet.getCell("F3").value =
              createContactInfo?.sessionsOfEvent?.[i]?.sessionContactPoint;
            worksheet.getCell("D3").value = "Onsite Contact*:";
            worksheet.getCell("D3").font = { size: 14 };

            worksheet.getCell("D4").value = "Invoice:";
            worksheet.getCell("D4").font = { size: 14 };

            worksheet.getCell("J1").value =
              `${createContactInfo?.sessionsOfEvent?.[i]?.venueAddressLine1}${createContactInfo?.sessionsOfEvent?.[i]?.venueAddressLine2 ? `, ${createContactInfo?.sessionsOfEvent?.[i]?.venueAddressLine2}` : ""}${createContactInfo?.sessionsOfEvent?.[i]?.venueCity ? `, ${createContactInfo?.sessionsOfEvent?.[i]?.venueCity}` : ""}${createContactInfo?.sessionsOfEvent?.[i]?.venueState ? `, ${createContactInfo?.sessionsOfEvent?.[i]?.venueState}` : ""}${createContactInfo?.sessionsOfEvent?.[i]?.venueZipCode ? `, ${createContactInfo?.sessionsOfEvent?.[i]?.venueZipCode}` : ""}`;
            worksheet.getCell("G1").value = "Address*:";
            worksheet.getCell("G1").font = { size: 14 };

            worksheet.getCell("G2").value = "Crew Coordinator:";
            worksheet.getCell("G2").font = { size: 14 };

            worksheet.getCell("J2").dataValidation = {
              type: "list",
              allowBlank: true,
              formulae: [
                `"${allCoordinators
                  ?.map((coordinator) => {
                    return `${coordinator?.fullName} (${coordinator?._id})`;
                  })
                  ?.join(",")}"`,
              ],
            };

            worksheet.getCell("G3").value = "Attire:";
            worksheet.getCell("G3").font = { size: 14 };

            worksheet.getCell("J3").dataValidation = {
              type: "list",
              allowBlank: true,
              formulae: [
                `"${[
                  "Blacks (Shorts OK)",
                  "Tech Blacks",
                  "Show Blacks",
                  "Dress Blacks",
                ]?.join(",")}"`,
              ],
            };

            worksheet.getCell("C7").dataValidation = {
              type: "list",
              allowBlank: true,
              formulae: [
                `"${allContractors
                  ?.map((contractor) => {
                    return `${contractor?.firstName} ${contractor?.lastName} (${contractor?._id})`;
                  })
                  ?.join(",")}"`,
              ],
            };

            let currRow = 7;

            let sessionPositions = [];

            for (
              let j = 0;
              j < createContactInfo?.sessionsOfEvent?.[i]?.position?.length;
              j++
            ) {
              for (
                let k = 0;
                k <
                createContactInfo?.sessionsOfEvent?.[i]?.position?.[j]
                  ?.positionData?.length;
                k++
              ) {
                sessionPositions.push(
                  createContactInfo?.sessionsOfEvent?.[i]?.position?.[j]
                    ?.positionData?.[k],
                );
              }
            }

            sessionPositions = [
              ...sessionPositions.sort((a, b) => {
                const aDt = new Date(a?.startDate);
                const bDt = new Date(b?.startDate);

                if (aDt < bDt) {
                  return -1;
                }

                if (aDt > bDt) {
                  return 1;
                }

                return 0;
              }),
            ];

            for (let i = 0; i < sessionPositions?.length; i++) {
              const position = sessionPositions?.[i];
              worksheet.getCell(`A${currRow}`).value = dayjs(
                position?.startDate,
              )?.format("MM/DD/YYYY");
              worksheet.getCell(`B${currRow}`).value = position?.positionName;
              worksheet.getCell(`G${currRow}`).value =
                position?.additionalComments;
              worksheet.getCell(`K${currRow}`).value = dateRegex.test(
                position?.timeIn?.split?.("T")?.[0],
              )
                ? dayjs(
                    convertFromUTCToGivenTimezone({
                      dateStr: position?.timeIn,
                      timezone: createContactInfo?.eventInfo?.eventTimezone,
                    }),
                  ).format("LT")
                : `${position?.timeIn} (${position?.numberOfHours})`;
              worksheet.getCell(`L${currRow}`).value = dateRegex.test(
                position?.timeOut?.split?.("T")?.[0],
              )
                ? dayjs(
                    convertFromUTCToGivenTimezone({
                      dateStr: position?.timeOut,
                      timezone: createContactInfo?.eventInfo?.eventTimezone,
                    }),
                  ).format("LT")
                : `${position?.timeOut} (${position?.numberOfHours})`;
              currRow++;
            }
          }

          const buffer = await workbook.xlsx.writeBuffer();
          FileSaver.saveAs(new Blob([buffer]), `${eventInfo?.eventName}.xlsx`);
          setIsDownloadUploadEventFromSheetLoading(false);
        },
        failureCallback: () => {
          dispatch({
            type: ALERT_DIALOG,
            payload: {
              open: true,
              title: "Error!",
              message:
                "Failed to fetch dropdown data required for the sheet. Please try again.",
            },
          });
        },
        params: {},
      }),
    );
    // dispatch(
    //   fetchAllCoordinatorAction({
    //     beforeCallback: () => {
    //       setIsDownloadUploadEventFromSheetLoading(true);
    //     },
    //     successCallback: ({ response }) => {
    //       dispatch(
    //         getAllContractorsAction({
    //           successCallback: async ({ response: allContractorsResponse }) => {
    //             dispatch(
    //               getAllClientsAction({
    //                 successCallback: async ({ response: allClientsResponse }) => {
    //                   const allCoordinators = response?.data?.data;
    //                   const allContractors = allContractorsResponse?.data?.data;
    //                   const clients = allClientsResponse?.data?.data;

    //                   const workbook = new ExcelJS.Workbook();

    //                   for (let i = 0; i < createContactInfo?.sessionsOfEvent?.length; i++) {
    //                     const worksheet = workbook.addWorksheet(createContactInfo?.sessionsOfEvent?.[i]?.sessionName);

    //                     worksheet.getRow(6).values = [
    //                       "Date*",
    //                       "Position*",
    //                       "Name",
    //                       "Phone",
    //                       "Email",
    //                       "SOW",
    //                       "Notes",
    //                       "CC",
    //                       "Client Rate",
    //                       "Rate",
    //                       "Call Start*",
    //                       "Call End*",
    //                       "Notes",
    //                       "Actual Start",
    //                       "1st Break",
    //                       "In",
    //                       "2nd Break",
    //                       "In",
    //                       "Actual End",
    //                       "OT",
    //                       "DT",
    //                       "Meal Penalty",
    //                       "Notes",
    //                     ];

    //                     for (let col = 1; col <= 23; col++) { // Example: Covering columns A to W
    //                       const cell = worksheet.getCell(5, col);
    //                       cell.fill = {
    //                         type: "pattern",
    //                         pattern: "solid",
    //                         fgColor: { argb: "FF808080" },
    //                       };
    //                     }

    //                     const positionTableCells = ["C", "D", "E"];
    //                     for (let i = 0; i < positionTableCells?.length; i++) {
    //                       const cell = worksheet.getCell(`${positionTableCells[i]}7`);
    //                       cell.fill = {
    //                         type: "pattern",
    //                         pattern: "solid",
    //                         fgColor: { argb: "FFD9EAD3" },
    //                       };
    //                       // Set black border
    //                       cell.border = {
    //                         top: { style: "thin", color: { argb: "FF000000" } },
    //                         left: { style: "thin", color: { argb: "FF000000" } },
    //                         bottom: { style: "thin", color: { argb: "FF000000" } },
    //                         right: { style: "thin", color: { argb: "FF000000" } },
    //                       };
    //                     }

    //                     worksheet.getRow(6).eachCell((cell, colNumber) => {
    //                       if (cell?._address === "A6") {
    //                         worksheet.getColumn(colNumber).width = 15; // Minimum width of 10
    //                       } else if (cell?._address === "B6") {
    //                         worksheet.getColumn(colNumber).width = 20; // Minimum width of 10
    //                       } else if (cell?._address === "C6") {
    //                         worksheet.getColumn(colNumber).width = 20; // Minimum width of 10
    //                       } else if (cell?._address === "D6") {
    //                         worksheet.getColumn(colNumber).width = 17; // Minimum width of 10
    //                       } else if (cell?._address === "E6") {
    //                         worksheet.getColumn(colNumber).width = 20; // Minimum width of 10
    //                       } else if (cell?._address === "F6") {
    //                         worksheet.getColumn(colNumber).width = 20; // Minimum width of 10
    //                       } else if (cell?._address === "G6") {
    //                         worksheet.getColumn(colNumber).width = 25; // Minimum width of 10
    //                       } else if (cell?._address === "H6") {
    //                         worksheet.getColumn(colNumber).width = 12; // Minimum width of 10
    //                       } else if (cell?._address === "I6") {
    //                         worksheet.getColumn(colNumber).width = 12; // Minimum width of 10
    //                       } else if (cell?._address === "J6") {
    //                         worksheet.getColumn(colNumber).width = 9; // Minimum width of 10
    //                       } else if (cell?._address === "K6") {
    //                         worksheet.getColumn(colNumber).width = 12; // Minimum width of 10
    //                       } else if (cell?._address === "L6") {
    //                         worksheet.getColumn(colNumber).width = 12; // Minimum width of 10
    //                       } else if (cell?._address === "M6") {
    //                         worksheet.getColumn(colNumber).width = 20; // Minimum width of 10
    //                       } else if (cell?._address === "N6") {
    //                         worksheet.getColumn(colNumber).width = 12; // Minimum width of 10
    //                       } else if (cell?._address === "O6") {
    //                         worksheet.getColumn(colNumber).width = 11; // Minimum width of 10
    //                       } else if (cell?._address === "P6") {
    //                         worksheet.getColumn(colNumber).width = 9; // Minimum width of 10
    //                       } else if (cell?._address === "Q6") {
    //                         worksheet.getColumn(colNumber).width = 11; // Minimum width of 10
    //                       } else if (cell?._address === "R6") {
    //                         worksheet.getColumn(colNumber).width = 9; // Minimum width of 10
    //                       } else if (cell?._address === "S6") {
    //                         worksheet.getColumn(colNumber).width = 12; // Minimum width of 10
    //                       } else if (cell?._address === "T6") {
    //                         worksheet.getColumn(colNumber).width = 7; // Minimum width of 10
    //                       } else if (cell?._address === "U6") {
    //                         worksheet.getColumn(colNumber).width = 7; // Minimum width of 10
    //                       } else if (cell?._address === "V6") {
    //                         worksheet.getColumn(colNumber).width = 15; // Minimum width of 10
    //                       } else if (cell?._address === "W6") {
    //                         worksheet.getColumn(colNumber).width = 20; // Minimum width of 10
    //                       }
    //                     });

    //                     const cells = [
    //                       "A6", "B6", "C6", "D6", "E6", "F6", "G6", "H6", "I6", "J6", "K6", "L6", "M6",
    //                       "N6", "O6", "P6", "Q6", "R6", "S6", "T6", "U6", "V6", "W6"
    //                     ];

    //                     for (let i = 0; i < cells?.length; i++) {
    //                       worksheet.getCell(cells[i]).font = {
    //                         bold: true,
    //                         size: 11
    //                       };

    //                       worksheet.getCell(cells[i]).fill = {
    //                         type: "pattern",
    //                         pattern: "solid",
    //                         fgColor: { argb: "FF76F8FC" }, // Cyan-like background
    //                       }

    //                       worksheet.getCell(cells[i]).border = {
    //                         top: { style: "thin", color: { argb: "FF000000" } }, // Black
    //                         left: { style: "thin", color: { argb: "FF000000" } },
    //                         bottom: { style: "thin", color: { argb: "FF000000" } },
    //                         right: { style: "thin", color: { argb: "FF000000" } },
    //                       };
    //                     }

    //                     worksheet.getCell("A7").value = dayjs().format("YYYY-MM-DD");
    //                     worksheet.getCell("K7").value = "10:00";
    //                     worksheet.getCell("L7").value = "17:00";

    //                     worksheet.getCell("C1").value = createContactInfo?.eventInfo?.eventName;
    //                     worksheet.getCell("A1").value = "Show*:";
    //                     worksheet.getCell("A1").font = { size: 14 };

    //                     worksheet.getCell("A2").value = "Client:";
    //                     worksheet.getCell("A2").font = { size: 14 };

    //                     worksheet.getCell("C2").value =
    //                       `${createContactInfo?.contactInfo?.firstName} ${createContactInfo?.contactInfo?.lastName} (${createContactInfo?.contactInfo?._id})`;
    //                     worksheet.getCell("C2").dataValidation = {
    //                       type: "list",
    //                       allowBlank: true,
    //                       formulae: [
    //                         `"${clients
    //                           ?.map((client) => {
    //                             return `${client?.firstName} ${client?.lastName} (${client?._id})`;
    //                           })
    //                           ?.join(",")}"`,
    //                       ],
    //                     };

    //                     worksheet.getCell("A3").value = "Job Number:";
    //                     worksheet.getCell("A3").font = { size: 14 };

    //                     worksheet.getCell("A4").value = "Estimate:";
    //                     worksheet.getCell("A4").font = { size: 14 };

    //                     worksheet.getCell("F1").value = createContactInfo?.eventInfo?.venue;
    //                     worksheet.getCell("D1").value = "Venue*:";
    //                     worksheet.getCell("D1").font = { size: 14 };

    //                     worksheet.getCell("D2").value = "Checkin:";
    //                     worksheet.getCell("D2").font = { size: 14 };
    //                     worksheet.getCell("F2").value = createContactInfo?.sessionsOfEvent?.[i]?.venue;

    //                     worksheet.getCell("F3").value = createContactInfo?.sessionsOfEvent?.[i]?.sessionContactPoint;
    //                     worksheet.getCell("D3").value = "Onsite Contact*:";
    //                     worksheet.getCell("D3").font = { size: 14 };

    //                     worksheet.getCell("D4").value = "Invoice:";
    //                     worksheet.getCell("D4").font = { size: 14 };

    //                     worksheet.getCell("J1").value = `${createContactInfo?.sessionsOfEvent?.[i]?.venueAddressLine1}${createContactInfo?.sessionsOfEvent?.[i]?.venueAddressLine2 ? `, ${createContactInfo?.sessionsOfEvent?.[i]?.venueAddressLine2}` : ""}${createContactInfo?.sessionsOfEvent?.[i]?.venueCity ? `, ${createContactInfo?.sessionsOfEvent?.[i]?.venueCity}` : ""}${createContactInfo?.sessionsOfEvent?.[i]?.venueState ? `, ${createContactInfo?.sessionsOfEvent?.[i]?.venueState}` : ""}${createContactInfo?.sessionsOfEvent?.[i]?.venueZipCode ? `, ${createContactInfo?.sessionsOfEvent?.[i]?.venueZipCode}` : ""}`;
    //                     worksheet.getCell("G1").value = "Address*:";
    //                     worksheet.getCell("G1").font = { size: 14 };

    //                     worksheet.getCell("G2").value = "Crew Coordinator:";
    //                     worksheet.getCell("G2").font = { size: 14 };

    //                     worksheet.getCell("J2").dataValidation = {
    //                       type: "list",
    //                       allowBlank: true,
    //                       formulae: [
    //                         `"${allCoordinators
    //                           ?.map((coordinator) => {
    //                             return `${coordinator?.fullName} (${coordinator?._id})`;
    //                           })
    //                           ?.join(",")}"`,
    //                       ],
    //                     };

    //                     worksheet.getCell("G3").value = "Attire:";
    //                     worksheet.getCell("G3").font = { size: 14 };

    //                     worksheet.getCell("J3").dataValidation = {
    //                       type: "list",
    //                       allowBlank: true,
    //                       formulae: [
    //                         `"${[
    //                             "Blacks (Shorts OK)",
    //                             "Tech Blacks",
    //                             "Show Blacks",
    //                             "Dress Blacks",
    //                           ]
    //                           ?.join(",")}"`,
    //                       ],
    //                     };

    //                     worksheet.getCell("C7").dataValidation = {
    //                       type: "list",
    //                       allowBlank: true,
    //                       formulae: [
    //                         `"${allContractors
    //                           ?.map((contractor) => {
    //                             return `${contractor?.firstName} ${contractor?.lastName} (${contractor?._id})`;
    //                           })
    //                           ?.join(",")}"`,
    //                       ],
    //                     };

    //                     let currRow = 7;

    //                     let sessionPositions = [];

    //                     for (let j = 0; j < createContactInfo?.sessionsOfEvent?.[i]?.position?.length; j++) {
    //                       for (let k = 0; k < createContactInfo?.sessionsOfEvent?.[i]?.position?.[j]?.positionData?.length; k++) {
    //                         sessionPositions.push(createContactInfo?.sessionsOfEvent?.[i]?.position?.[j]?.positionData?.[k]);
    //                       }
    //                     }

    //                     sessionPositions = [...sessionPositions.sort((a, b) => {
    //                       const aDt = new Date(a?.startDate);
    //                       const bDt = new Date(b?.startDate);

    //                       if (aDt < bDt) {
    //                         return -1;
    //                       }

    //                       if (aDt > bDt) {
    //                         return 1;
    //                       }

    //                       return 0;
    //                     })];

    //                     for (let i = 0; i < sessionPositions?.length; i++) {
    //                       const position = sessionPositions?.[i];
    //                       worksheet.getCell(`A${currRow}`).value = dayjs(position?.startDate)?.format("MM/DD/YYYY");
    //                       worksheet.getCell(`B${currRow}`).value = position?.positionName;
    //                       worksheet.getCell(`G${currRow}`).value = position?.additionalComments;
    //                       worksheet.getCell(`K${currRow}`).value = dateRegex.test(position?.timeIn?.split?.("T")?.[0]) ?
    //                         dayjs(
    //                           convertFromUTCToGivenTimezone({
    //                             dateStr: position?.timeIn,
    //                             timezone: createContactInfo?.eventInfo?.eventTimezone
    //                           })
    //                         ).format("LT")
    //                       : `${position?.timeIn} (${position?.numberOfHours})`;
    //                       worksheet.getCell(`L${currRow}`).value = dateRegex.test(position?.timeOut?.split?.("T")?.[0]) ?
    //                       dayjs(
    //                         convertFromUTCToGivenTimezone({
    //                           dateStr: position?.timeOut,
    //                           timezone: createContactInfo?.eventInfo?.eventTimezone
    //                         })
    //                       ).format("LT")
    //                       : `${position?.timeOut} (${position?.numberOfHours})`;
    //                       currRow++;
    //                     }
    //                   }

    //                   const buffer = await workbook.xlsx.writeBuffer();
    //                   FileSaver.saveAs(new Blob([buffer]), `${eventInfo?.eventName}.xlsx`);
    //                   setIsDownloadUploadEventFromSheetLoading(false);
    //                 },
    //                 failureCallback: ({ error }) => {
    //                   dispatch({
    //                     type: ALERT_DIALOG,
    //                     payload: {
    //                       open: true,
    //                       title: "Error",
    //                       message: "Failed to fetch the client list for the sheet dropdown. Please try again."
    //                     }
    //                   })
    //                 }
    //               })
    //             )
    //           },
    //           failureCallback: ({ error }) => {
    //             dispatch({
    //               type: ALERT_DIALOG,
    //               payload: {
    //                 open: true,
    //                 title: "Error",
    //                 message: "Failed to fetch contractor list for sample sheet. Please try again"
    //               }
    //             })
    //           }
    //         })
    //       )
    //     },
    //     failureCallback: () => {},
    //   }),
    // );
  };
  // Handlers end...

  // useEffects start...
  useEffect(() => {
    dispatch(getSessionssOfSpecificEvent(eventInfo?._id));
  }, []);
  // useEffect(() => {
  //     if (searchTerm) {
  //         // const searchRegex = new RegExp(escapeSearchRegex(searchTerm), "i");
  //         // if (searchTerm) {
  //         //   const filterPositions = positionOptions.filter((elem) =>
  //         //     // searchRegex.test(elem?.value) Original
  //         //     elem?.label?.toLowerCase()?.includes?.(searchTerm?.toLowerCase())
  //         //   );
  //         //   setOptions(filterPositions);
  //         // } else {
  //         //   setOptions(positionOptions);
  //         // }
  //         // const searchRegex = new RegExp(escapeSearchRegex(searchTerm), "i");
  //         // if (searchTerm) {
  //         //   const filterPositions = positionOptions.filter((elem) =>
  //         //     // searchRegex.test(elem?.value) Original
  //         //     elem?.label?.toLowerCase()?.includes?.(searchTerm?.toLowerCase())
  //         //   );
  //         //   setOptions(filterPositions);
  //         // } else {
  //         //   setOptions(positionOptions);
  //         // }

  //         // if (searchTerm) {
  //         //   dispatch(getSearchPositions(searchTerm));
  //         // }

  //         const debounce = setTimeout(() => {
  //           dispatch(getSearchPositions(searchTerm));
  //         }, [1000]);

  //         return () => {
  //           clearTimeout(debounce);
  //         };
  //     }
  // }, [searchTerm, dispatch]);

  useEffect(() => {
    dispatch(getAllPositions({}));
  }, [dispatch]);

  useEffect(() => {
    setOptions(
      positionsReducer?.allPositions?.data?.map?.((position) => {
        return {
          ...position,
          _id: position?.Id || position?._id,
          value: position?.Id || position?._id,
          label: position?.positionName,
        };
      }),
    );
  }, [positionsReducer?.allPositions?.data]);

  useEffect(() => {
    if (selectedSessionId) {
      let session = createContactInfo?.sessionsOfEvent?.filter?.((session) => {
        return session?._id === selectedSessionId;
      })?.[0];

      dispatch(
        setSessionData({
          session,
        }),
      );
    }
  }, [selectedSessionId, dispatch]);

  useEffect(() => {
    let sessions = viewAllSessionsPositions
      ? createContactInfo?.sessionsOfEvent
      : createContactInfo?.sessionsOfEvent?.filter?.((session) => {
          return session?._id === selectedSessionId;
        });

    let sessionPositionsTableDataTemp = [];

    for (let session of sessions) {
      for (let i = 0; i < session?.position?.length; i++) {
        for (let j = 0; j < session?.position?.[i]?.positionData?.length; j++) {
          sessionPositionsTableDataTemp.push({
            ...session?.position?.[i]?.positionData?.[j],
            timeIn: dateRegex.test(
              session?.position?.[i]?.positionData?.[j]?.timeIn?.split?.(
                "T",
              )?.[0],
            )
              ? convertFromUTCToGivenTimezone({
                  dateStr: session?.position?.[i]?.positionData?.[j]?.timeIn,
                  timezone: eventInfo?.eventTimezone,
                })
              : session?.position?.[i]?.positionData?.[j]?.timeIn,
            timeOut: dateRegex.test(
              session?.position?.[i]?.positionData?.[j]?.timeOut?.split?.(
                "T",
              )?.[0],
            )
              ? convertFromUTCToGivenTimezone({
                  dateStr: session?.position?.[i]?.positionData?.[j]?.timeOut,
                  timezone: eventInfo?.eventTimezone,
                })
              : session?.position?.[i]?.positionData?.[j]?.timeOut,
            positionId: session?.position?.[i]?.positionId,
            session,
          });
        }
      }
    }

    const sessionPositionsGroupedObj = {};
    let sessionPositionsGroupedArr = [];
    let timeIn;

    for (let i = 0; i < sessionPositionsTableDataTemp?.length; i++) {
      timeIn = getFullDateStr(sessionPositionsTableDataTemp?.[i]?.timeIn);

      if (!sessionPositionsGroupedObj[timeIn]) {
        sessionPositionsGroupedObj[timeIn] = [
          sessionPositionsTableDataTemp?.[i],
        ];
      } else {
        sessionPositionsGroupedObj[timeIn]?.push(
          sessionPositionsTableDataTemp?.[i],
        );
      }
    }

    sessionPositionsGroupedArr = Object.entries(
      sessionPositionsGroupedObj,
    )?.sort((a, b) => {
      const aDt = new Date(a?.[0]);
      const bDt = new Date(b?.[0]);

      if (aDt < bDt) {
        return -1;
      }

      if (aDt > bDt) {
        return 1;
      }

      return 0;
    });

    sessionPositionsTableDataTemp = [];

    for (let i = 0; i < sessionPositionsGroupedArr?.length; i++) {
      for (let j = 0; j < sessionPositionsGroupedArr?.[i]?.[1]?.length; j++) {
        sessionPositionsTableDataTemp?.push(
          sessionPositionsGroupedArr?.[i]?.[1]?.[j],
        );
      }
    }

    // sessionPositionsTableDataTemp = sessionPositionsTableDataTemp
    //   ?.filter((position, positionIdx) => {
    //     return (positionIdx >= ((positionsTablePageNo - 1) * positionsTableLimit) &&
    //       positionIdx < ((positionsTablePageNo - 1) * positionsTableLimit) + positionsTableLimit);
    //   });

    setSessionPositionsTableData(sessionPositionsTableDataTemp);
  }, [
    positionsTablePageNo,
    positionsTableLimit,
    eventInfo?.eventTimezone,
    createContactInfo?.sessionStep1?._id,
    createContactInfo?.sessionsOfEvent,
    selectedSessionId,
    viewAllSessionsPositions,
  ]);

  React.useEffect(() => {
    setSelectedSessionId(createContactInfo?.sessionsOfEvent?.[0]?._id);
  }, [createContactInfo?.sessionsOfEvent?.[0]?._id]);

  React.useEffect(() => {
    let sessionIds = viewAllSessionsPositions
      ? createContactInfo?.sessionsOfEvent?.map((item) => item?._id)
      : viewPositionsData?.selectedSessions?.map?.((session) => session?._id);

    setViewPositionsData((viewPositionsData) => {
      return {
        ...viewPositionsData,
        positions: getPositionsDataHandler({
          sessions: createContactInfo?.sessionsOfEvent?.filter?.((session) => {
            return sessionIds?.includes?.(session?._id);
          }),
        }),
      };
    });

    // const sessionPositionsTableData = getPositionsDataHandler({
    //   sessions: [
    //     createContactInfo?.sessionsOfEvent?.[0],
    //     createContactInfo?.sessionsOfEvent?.[1]
    //   ]
    // })

    // const sessionPositions = [];

    // for (let i = 0; i < sessionPositionsTableData?.length; i++) {
    //   const sessionIdx = sessionPositions?.findIndex?.(session => {
    //     return (session?.find?.(position => {
    //       return (position?.session?._id === sessionPositionsTableData?.[i]?.session?._id);
    //     }))
    //   });

    //   if (sessionIdx >= 0) {
    //     sessionPositions?.[sessionIdx]?.push(sessionPositionsTableData?.[i]);
    //   } else {
    //     sessionPositions?.push(
    //       [sessionPositionsTableData?.[i]]
    //     );
    //   }
    // }

    // setViewPositionsData(sessionPositions);
  }, [
    viewAllSessionsPositions,
    viewPositionsData?.selectedSessions,
    createContactInfo?.sessionStep1?._id,
    createContactInfo?.sessionsOfEvent,
    eventInfo?.eventTimezone,
  ]);

  // reset form...
  React.useEffect(() => {
    if (typeof createContactInfo?.reset?.count === "number") {
      resetForm();
    }
  }, [createContactInfo?.reset?.count]);

  React.useEffect(() => {
    setViewPositionsData((viewPositionsData) => {
      return {
        ...viewPositionsData,
        selectedSessions: createContactInfo?.sessionsOfEvent?.filter?.(
          (session) => {
            if (viewAllSessionsPositions) return true;
            return session?._id === selectedSessionId;
          },
        ),
      };
    });
  }, [selectedSessionId, viewAllSessionsPositions]);
  // useEffects end...

  return (
    <>
      {!isEventSubmitted ? (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box
            className={`${styles["dataBox"]}${isPreview ? " custom-scroll-bar" : ""}`}
            sx={
              isPreview
                ? {
                    background: "rgb(0, 0, 0)",
                    padding: isSmallScreen ? "2rem 1rem" : "2.75rem 2.5rem",
                    paddingTop: isSmallScreen ? "1rem" : "1.75rem",
                    height: "100%",
                    overflowY: "auto",
                  }
                : {
                    padding: isSmallScreen ? "2.5rem 1rem" : "3.75rem 2.5rem",
                    position: "relative",
                  }
            }
          >
            {isPreview ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Typography fontSize={"1rem"} mr={"0.25rem"}>
                  Help
                </Typography>
                <Tooltip title={"Get Help"} arrow placement="top">
                  <img
                    src={InfoImage}
                    style={{ height: "1rem", width: "1rem", cursor: "pointer" }}
                  />
                </Tooltip>
                <CustomSwitch
                  sx={{ scale: "0.75" }}
                  checked={helpStatus}
                  onClick={() => {
                    dispatch(toggleHelper(!helpStatus));
                  }}
                />
              </Box>
            ) : (
            <Box
              sx={{
                position: "absolute",
                top: "0.5rem",
                right: "0.5rem",
              }}
            >
              <Box
                sx={{
                  position: "relative",
                  alignSelf: "center",
                }}
              >
                <GenericTransparentBtn
                  style={{
                    width: "2rem",
                    height: "1rem",
                  }}
                  onClick={() => {
                    setShowMenuItems((showMenuItems) => {
                      return {
                        ...showMenuItems,
                        uploadEventFromSheetButtons:
                          !showMenuItems?.uploadEventFromSheetButtons,
                      };
                    });
                  }}
                >
                  <MoreHoriz
                    sx={{
                      fontSize: "2rem",
                    }}
                  />
                </GenericTransparentBtn>

                {showMenuItems?.uploadEventFromSheetButtons ? (
                  <Box
                    sx={{
                      position: "absolute",
                      top: "2rem",
                      right: "0",
                      zIndex: "10",
                    }}
                  >
                    <ReusableParentContainer
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "0.5rem",
                        opacity: "1",
                        padding: "1rem",
                        width: "max-content",
                        height: "fit-content",
                      }}
                    >
                      <>
                        <Button
                          sx={{
                            borderRadius: "4px",
                            border: "1px solid #FFF",
                            background:
                              "linear-gradient(99deg, #F0F 0%, #8F00FF 100.41%) !important",
                            boxShadow:
                              "0px 0px 20px 0px rgba(209, 117, 182, 0.40)",
                            minWidth: "auto",
                            padding: "5px 10px !important",
                          }}
                          // className="btn-pink"
                          onClick={downloadEventUploadSheetHandler}
                        >
                          {isDownloadUploadEventFromSheetLoading ? (
                            <CircularProgress size={22} />
                          ) : (
                            "Download event in a sheet"
                          )}
                        </Button>
                      </>
                    </ReusableParentContainer>
                  </Box>
                ) : null}
              </Box>
            </Box>
            )}

            {!isPreview && createContactInfo?.loadingStep4 ? (
              <LoadingOverlay open={true} />
            ) : (
              <>
                <Grid container spacing={2}>
                  <Grid item xs={isMediumScreen ? 12 : 6}>
                    <EventInformation
                      onDuplicateChanged={() => {
                        dispatch(resetCreateEventSlice());
                        closeHandler?.();
                        navigate("/event/partials");
                      }}
                      event={{
                        ...eventInfo,
                        eventStart: eventInfo?.eventStart,
                        eventEnd: eventInfo?.eventEnd,
                        venueAddress: eventInfo?.venue
                          ? isSmallScreen
                            ? eventInfo?.venue
                            : `${eventInfo?.venue}, ${eventInfo?.venueCity}, ${eventInfo?.venueState}`
                          : "",
                      }}
                    />
                  </Grid>
                  <Grid item xs={isMediumScreen ? 12 : 6}>
                    <ContactInformation contact={contactInfo} />
                  </Grid>
                </Grid>
                <Box
                  sx={{
                    width: "100%",
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="h1"
                    sx={isPreview ? { marginY: "1.25rem !important" } : undefined}
                    className={styles.sectionTitle}
                  >
                    Sessions
                  </Typography>

                  <Box
                    sx={{
                      position: "absolute",
                      right: "0",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.25rem",
                    }}
                  >
                    <Checkbox
                      name={"allSessions"}
                      onChange={(e) => {
                        setViewAllSessionsPositions(e?.target?.checked);
                      }}
                      sx={{
                        color: getCssVariableHandler({
                          variableName: "--font-rgb",
                        }),
                        padding: "0",
                      }}
                      checked={viewAllSessionsPositions}
                    />
                    <InputLabel
                      sx={{
                        marginBottom: "0 !important",
                      }}
                    >
                      All sessions
                    </InputLabel>
                  </Box>
                </Box>
                {/* <Typography variant="h1" className={styles.sectionTitle}>
                  Sessions
                </Typography> */}
                <Grid container spacing={2}>
                  <Grid
                    item
                    xs={
                      isMediumScreen
                        ? 12
                        : createContactInfo?.sessionsOfEvent?.length > 0
                          ? 4
                          : 12
                    }
                  >
                    <Box>
                      <SessionList
                        style={{
                          width: "100% !important",
                        }}
                        selectedSessionId={selectedSessionId}
                        eventInfo={eventInfo}
                        sessionsOfEvent={createContactInfo?.sessionsOfEvent}
                        viewAllSessions={viewAllSessionsPositions}
                        // setStep={setStep}
                        editSessionCallback={editSessionCallback}
                        setEditSessionData={setEditSessionData}
                        setSelectedSessionId={setSelectedSessionId}
                        onClickGivenSessionHandler={onClickGivenSessionHandler}
                        deleteSessionParentHandler={deleteSessionHandler}
                        toBeDeletedSession={toBeDeletedSession}
                        setToBeDeletedSession={setToBeDeletedSession}
                        deleteSessionLoading={deleteSessionLoading}
                        setDeleteSessionLoading={setDeleteSessionLoading}
                        confirmPassword={confirmPassword}
                        setConfirmPassword={setConfirmPassword}
                      />
                    </Box>
                  </Grid>
                  {viewAllSessionsPositions ||
                  (createContactInfo?.sessionsOfEvent?.length > 0 &&
                    selectedSession) ? (
                    viewAllSessionsPositions ||
                    selectedSession?.position
                      ?.map?.((item) =>
                        item?.positionData?.map?.((el) => ({
                          ...el,
                          positionId: item?.positionId,
                        })),
                      )
                      ?.flat?.()?.length > 0 ? (
                      <>
                        <Grid item xs={isMediumScreen ? 12 : 8}>
                          <SessionPositions
                            viewAllSessionsPositions={viewAllSessionsPositions}
                            getSessionOfPosition={getSessionOfPosition}
                            session={selectedSession}
                            sessionPositionsUI={
                              createContactInfo?.sessionPositionsUI
                            }
                            sessionPositionsStyles={{
                              tableContainer: {
                                maxHeight: isPreview ? "40vh" : "700px",
                              },
                            }}
                            sessionPositions={sessionPositionsTableData}
                            handleEditPosition={handleEditPosition}
                            handleDeletePosition={handleDeletePosition}
                            eventInfo={eventInfo}
                            setSearchTerm={setSearchTerm}
                            resetForm={resetForm}
                            setValues={setValues}
                            setInitialValues={setInitialValues}
                            setEditId={setEditingSessionPositionId}
                            refetchEventDetailsHandler={afterAddPositions}
                            onClickViewPositions={() => {
                              setSheetStatus({ positionSheet: true });
                            }}
                            openNewTab={true}
                          />
                        </Grid>
                        <Grid item xs={4}></Grid>
                        <Grid item xs={8} textAlign={"center"}>
                          {/* <UnderlineButton
                            title={"View Positions"}
                            onClick={() =>
                              setSheetStatus({ positionSheet: true })
                            }
                            styles={{
                              fontSize: "1.25rem",
                            }}
                          /> */}
                        </Grid>
                      </>
                    ) : (
                      <Grid item xs={6}>
                        <Typography>No session positions</Typography>
                      </Grid>
                    )
                  ) : null}
                </Grid>
                {/* section to ask if they want to send email to client */}
                {!isPreview ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.5rem",
                    mt: 3,
                  }}
                >
                  <Checkbox
                    name="sendemail"
                    sx={{
                      cursor: "pointer",
                      padding: "0",
                      color: getCssVariableHandler({
                        variableName: "--white-rgb",
                      }),
                      "&.Mui-checked": {
                        color: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                        "& svg": {
                          fill: getCssVariableHandler({
                            variableName: "--primary-pink-hex",
                          }),
                        },
                      },
                    }}
                    checked={!!sendEmail}
                    onChange={(e) => {
                      onSendEmailChange(e?.target?.checked);
                    }}
                  />
                  <Typography>
                    {isUserRole(
                      USER_ROLES.ADMIN,
                      USER_ROLES.SUPERADMIN,
                      USER_ROLES.COORDINATOR,
                      USER_ROLES.FREELANCE_EC,
                    )
                      ? "Send and email to client informing event is added to ShowPhaze"
                      : "Get a summary email about event is added"}
                  </Typography>
                </Box>
                ) : null}
              </>
            )}
          </Box>
          {!isPreview ? (
          <Box className={styles.bottomBtnBox}>
            {currentStep > 1 && !editEventButton ? (
              <Button
                className={styles.btnBack}
                onClick={(e) => {
                  setStep(1);
                  handlePrevStep();
                }}
              >
                Back
              </Button>
            ) : null}

            {auth?.userToken && editEventButton ? (
              <Button
                className={styles.btnBack}
                onClick={() => {
                  setCurrentStep(1);
                }}
              >
                Edit Event
              </Button>
            ) : null}
            {currentStep === 4 ? (
              <Button
                className={styles.btnNext}
                onClick={(e) => {
                  if (checkAtleastOneSessionAndPositionHandler()) {
                    dispatch(
                      updateSubmittedKey({
                        payload: {
                          sentEmailToClientOnEventSubmission: sendEmail,
                        },
                        eventId: eventInfo?._id,
                        userAuth: auth,
                        successCallback: submitEventSuccessCallback,
                        failureCallback: (msg) => {
                          dispatch(
                            alertDialogAciton({
                              open: true,
                              title: "Error",
                              message: msg || "Fail to submit event",
                            }),
                          );
                        },
                      }),
                    );
                  } else {
                    // alert(`Please create one session and one position!`);
                    dispatch({
                      type: ALERT_DIALOG,
                      payload: {
                        open: true,
                        title: "Error!",
                        message: "Please create one session and one position!",
                      },
                    });
                  }
                }}
                disabled={createContactInfo?.updateSubmittedKeyLoading}
              >
                {createContactInfo?.updateSubmittedKeyLoading ? (
                  <CircularProgress size={22} />
                ) : (
                  "Submit"
                )}
              </Button>
            ) : null}
          </Box>
          ) : null}
          <Modal
            open={Boolean(editingSessionPositionId)}
            onClose={closeEditSessionPositionModalHandler}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              sx={
                isPreview
                  ? {
                      maxWidth: "75vw",
                      maxHeight: "75vh",
                      "@media (max-width: 600px)": { maxWidth: "97vw" },
                    }
                  : {
                      width: "auto",
                      height: "auto",
                      "@media (max-width: 600px)": {
                        width: "97vw",
                        height: "90vh",
                      },
                    }
              }
            >
              <ReusableParentContainer
                style={{
                  width: "100%",
                  height: "100%",
                  background: "rgb(0, 0, 0)",
                }}
              >
                <Grid
                  className={`${sessionStyles.formDataBox}`}
                  sx={{
                    // width: '100% !important',
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    paddingRight: "0 !important",
                    "@media (max-width: 600px)": {
                      position: "absolute",
                      top: "0",
                      left: "0",
                      marginTop: "15px",
                      marginBottom: "15px",
                      // padding: "1.5rem 0.5rem",
                    },
                  }}
                >
                  <AddPositionForm
                    mode="edit"
                    formik={formik}
                    session={{
                      ...selectedSession,
                      sessionStart:
                        createContactInfo?.sessionData?.sessionStart,
                      sessionEnd: createContactInfo?.sessionData?.sessionEnd,
                    }}
                  />

                  <Grid
                    item
                    sx={{
                      width: "100%",
                    }}
                  >
                    <Box className={sessionStyles.bottomBtn}>
                      <Button
                        className={`${sessionStyles.BtnPosition} ${sessionStyles.BtnPositionPrimary}`}
                        onClick={() => {
                          const valuesObj = {
                            ...values,
                            timeIn: new Date(values?.timeIn),
                            timeOut: new Date(values?.timeOut),
                          };

                          const sessionStep2FormObj = {
                            ...createContactInfo?.sessionStep2Form,
                            timeIn: new Date(
                              createContactInfo?.sessionStep2Form?.timeIn,
                            ),
                            timeOut: new Date(
                              createContactInfo?.sessionStep2Form?.timeOut,
                            ),
                          };

                          if (lodash?.isEqual(valuesObj, sessionStep2FormObj)) {
                            alert(`No changes made!`);
                            return;
                          }

                          submitForm();
                        }}
                      >
                        {editingSessionPositionId ? (
                          createContactInfo?.sessionPositionsUI
                            ?.updateSessionPositionLoading ? (
                            <CircularProgress size={22} />
                          ) : (
                            "Edit Position"
                          )
                        ) : createContactInfo?.sessionPositionsUI
                            ?.addSessionPositionLoading ? (
                          <CircularProgress size={22} />
                        ) : (
                          "Add Position"
                        )}
                      </Button>

                      {editingSessionPositionId ? (
                        <Button
                          className={sessionStyles.BtnPosition}
                          sx={{
                            backgroundColor: `${getCssVariableHandler({
                              variableName: `--primary-pink-hex`,
                            })} !important`,
                          }}
                          onClick={() => {
                            cancelSessionPositionEditHandler();
                          }}
                        >
                          Cancel
                        </Button>
                      ) : null}
                    </Box>
                  </Grid>
                </Grid>
              </ReusableParentContainer>
            </Box>
          </Modal>

          {sheetStatus?.positionSheet && (
            <SessionPositionEditableSheetOptimized
              successCallback={() => {}}
              // data={sessionPositionsTableData}
              data={viewPositionsData?.positions}
              session={selectedSession}
              // sessions={[selectedSession]}
              sessions={viewPositionsData?.selectedSessions}
              sessionList={createContactInfo?.sessionsOfEvent}
              eventInfo={eventInfo}
              open={sheetStatus?.positionSheet}
              handleClose={() => {
                setSheetStatus({ positionSheet: false });
              }}
              selectSession={onClickGivenSessionHandler}
              viewPositionsData={viewPositionsData}
              setViewPositionsData={setViewPositionsData}
              allowCopyPositions
            />
          )}
        </LocalizationProvider>
      ) : (
        <>
          <Congratulations
            homeButtonHandler={homeButtonHandler}
            newEventHandler={newEventHandler}
            NavButtonsComponent={NavButtonsComponent}
            // navButtonsComponentProps={{
            //     closeHandler
            // }}
            navButtonsComponentProps={{
              ...navButtonsComponentProps,
              setCurrentStep,
            }}
            setCurrentStep={setCurrentStep}
          />
        </>
      )}
    </>
  );
};

export default EventDetails;

EventDetails.propTypes = {
  sendEmail: PropTypes.bool,
  onSendEmailChange: PropTypes.func,
  variant: PropTypes.oneOf(["step", "preview"]),
  handlePrevStep: PropTypes.func,
  handleNextStep: PropTypes.func,
  editSessionCallbackParent: PropTypes.func,
};

CongratulationsNavButtonsVariant1.propTypes = {
  homeButtonHandler: PropTypes.func,
  newEventHandler: PropTypes.func,
};

CongratulationsNavButtonsVariant2.propTypes = {
  closeHandler: PropTypes.func,
};
